import React from "react";
import { useNavigate } from "react-router-dom";
import "./Contact.css";

import contactImg from "../assets/contact-illustration.png";

import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaCommentDots,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Contact = () => {
  const navigate = useNavigate();

  return (
    <div className="contact-page">
      <div className="breadcrumb">
        <span className="home" onClick={() => navigate("/")}>
          Home
        </span>
        <span> / </span>
        <span className="active">Contact</span>
      </div>

      <div className="contact-wrapper">
        <div className="contact-left">
          <img src={contactImg} alt="contact" />
        </div>

        <div className="contact-right">
          <div className="contact-form">
            <h2>Send Message</h2>

            <div className="input-box">
              <FaUser />
              <input type="text" placeholder="Full Name" />
            </div>

            <div className="input-box">
              <FaEnvelope />
              <input type="email" placeholder="Email Address" />
            </div>

            <div className="input-box">
              <FaPhone />
              <input type="text" placeholder="Mobile Number" />
            </div>

            <div className="input-box textarea">
              <FaCommentDots />
              <textarea placeholder="Your Message"></textarea>
            </div>

            <button className="submit-btn">SUBMIT</button>
          </div>

          <div className="contact-info">
            <h3>Get In Touch</h3>

            <p>
              <FaMapMarkerAlt /> Hyderabad, Telangana 500001
            </p>
            <p>
              <FaPhone /> +91 9573470659{" "}
            </p>
            <p>
              <FaEnvelope /> hr@aapsplacements.in{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
